import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { completeEmergentSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean the session_id out of the URL immediately.
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await completeEmergentSession(sessionId);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      }
    })();
  }, [completeEmergentSession, navigate]);

  return (
    <div className="id-surface flex min-h-screen items-center justify-center px-6">
      <div className="flex flex-col items-center gap-4 text-center">
        {!error ? (
          <>
            <Loader2 className="h-9 w-9 animate-spin text-[var(--id-gold)]" />
            <p className="id-serif text-2xl text-[var(--id-charcoal)]">Signing you in…</p>
            <p className="id-sans text-sm text-[var(--id-charcoal)]/60">Bringing you into Intrinsic Daily.</p>
          </>
        ) : (
          <>
            <p className="id-serif text-2xl text-[var(--id-charcoal)]">We couldn't complete sign-in</p>
            <p className="id-sans text-sm text-[var(--id-charcoal)]/70">{error}</p>
            <p className="id-sans text-xs text-[var(--id-charcoal)]/50">Redirecting you back…</p>
          </>
        )}
      </div>
    </div>
  );
}
